module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1aDKO"))).then(() => parcelRequire('7ptcr'));